import 'angularjs-geolocation';

export default 'geolocation';



// WEBPACK FOOTER //
// ./src/common/wrappers/angularjs-geolocation.js